<template>
  <div class="cWrapper">
    <el-card><el-row class="title-biaoti">支付商品配置</el-row>
      <el-row class="search"><el-select style="width: 160px" v-model="search.channel" placeholder="请选择渠道" clearable=""
          filterable="">
          <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-button type="primary" @click="query(1)" :loading="login"> 查询 </el-button>
        <el-button type="warning" @click="operate(1)"> 新增 </el-button>
        <el-button type="danger" @click="clone(1)"> 克隆 </el-button>
      </el-row>
      <el-row>
        <el-table height="60vh" :data="dataList" style="width: 100%" v-loading="login" border>
          <el-table-column prop="productId" label="商品ID" align="center" sortable>
          </el-table-column>
          <el-table-column prop="id" label="ID" align="center" sortable>
          </el-table-column>
          <el-table-column prop="channel" label="渠道" align="center" sortable>
          </el-table-column>
          <el-table-column prop="channelProductId" label="渠道商品ID" align="center" sortable>
          </el-table-column>
          <el-table-column prop="productPrice" label="商品价格" align="center" sortable :sort-method="sortByPrice">
          </el-table-column>
          <el-table-column prop="payChannel" label="支付渠道" align="center" sortable>
            <template slot-scope="scope">{{
              payChannelType[scope.row.payChannel]
            }}</template>
          </el-table-column>
          <el-table-column prop="productDesc" label="描述" align="center" sortable>
          </el-table-column>
          <el-table-column label="是否使用" align="center" sortable>
            <template slot-scope="scope">
              <el-tag v-if="scope.row.hasMatchGoods == 1" type="success">使用</el-tag>
              <el-tag v-else type="danger">未使用</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ctime" label="创建时间" align="center" sortable>
          </el-table-column>
          <el-table-column prop="mtime" label="修改时间" align="center" sortable>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200px">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="operate(2, scope.row)">编辑</el-button>
              <el-button v-if="scope.row.hasMatchGoods == 0" type="danger" size="mini" @click="deleteProduct(scope.row.id)">删除</el-button>
            </template>
          </el-table-column></el-table></el-row>
      <!-- 分页 -->
      <el-row>
        <el-pagination background layout="total,sizes, prev, pager, next,jumper" :total="total" :page-size="pageSize"
          :current-page.sync="currentPage" 
          @size-change="handleSizeChange" @current-change="guaranteedHandleCurrentChange">
        </el-pagination>
      </el-row>
    </el-card>
    <el-dialog :title="type === 1 ? '新增支付商品' : '编辑支付商品'" :visible.sync="dialog" width="50%" :before-close="handleClose">
      <div class="item">
        <span>渠道</span><el-select v-model="product.channel" placeholder="请选择渠道" clearable="" filterable="">
          <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>商品ID</span><el-input type="text" v-model="product.productId"></el-input>
      </div>
      <div class="item">
        <span>渠道商品ID</span><el-input type="text" v-model="product.channelProductId"></el-input>
      </div>
      <div class="item">
        <span>支付渠道</span>
        <el-select v-model="product.payChannel" placeholder="请选择支付渠道" clearable="" filterable="">
          <el-option v-for="(val, key, ind) in payChannelType" v-bind:key="ind" :label="val"
            :value="key - 0"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>商品价格</span><el-input type="text" v-model="product.productPrice"></el-input>
      </div>
      <!-- <div class="item">
        <span>商品名称</span><el-input type="text" v-model="product.productId"></el-input>
      </div> -->
      <div class="item">
        <span>描述</span><el-input type="text" v-model="product.productDesc"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyProduct" type="primary" :loading="submitLoad">{{
          type === 1 ? "新 增" : "编 辑"
        }}</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-drawer title="克隆" size="40%" :visible.sync="cloneDrawer" direction="rtl" :before-close="closeClone">
      <div class="alist">
        <div class="item">
          <span>源渠道：</span>
          <el-select v-model="cloneData.fromChannel" @change="queryNew" placeholder="请选择渠道" clearable="" filterable="">
            <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>目标渠道：</span>
          <el-select v-model="cloneData.toChannel" placeholder="请选择渠道" clearable="" filterable="">
            <el-option v-for="(item, itemIndex) in channelList" v-bind:key="itemIndex" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>是否强制导入：</span><el-switch style="display: block" v-model="cloneData.forceClone" active-color="#13ce66"
            inactive-color="#ff4949" active-text="是" inactive-text="否" :active-value="true" :inactive-value="false">
          </el-switch>
        </div>
        <div class="item">
          <span>自动替换渠道商品ID：</span><el-switch style="display: block" v-model="cloneData.autoPlace" active-color="#13ce66"
            inactive-color="#ff4949" active-text="是" inactive-text="否" :active-value="true" :inactive-value="false">
          </el-switch>
        </div>
        <div class="item" v-if="cloneData.autoPlace">
          <el-input v-model="cloneData.searchContent" placeholder="请输入查找内容"></el-input>
        </div>
        <p v-if="cloneData.autoPlace">替换为</p>
        <div class="item" v-if="cloneData.autoPlace">
          <el-input v-model="cloneData.placeContent" placeholder="请输入替换内容"></el-input>
        </div>
        <div class="item">
          <el-button type="primary" @click="clone(2)">克隆 </el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { UTCTimeToDate } from "@/utils/common";
import { newChannelList } from "@/utils/normalApi.js";
export default {
  data() {
    return {
      search: { channel: "" },
      dataList: [],
      login: false,
      channelList: [],
      dialog: false,
      submitLoad: false,
      payChannelType: {
        0: "谷歌内购",
        1: "谷歌订阅",
        10: "苹果内购",
        9: "苹果订阅",
        11: "华为内购",
        12: "华为订阅",
        13: "vivo内购",
        14: "中台支付",
        15: "中台订阅",
        20: "telegram支付",
        21: "币商进行三方支付",
        120: "tap支付",
        125: "茄子支付",
      },
      type: 1, //1新增2编辑
      product: {
        channel: "",
        channelProductId: "",
        id: "",
        operator: "",
        payChannel: "",
        productDesc: "",
        productId: "",
        productPrice: "",
      },
      cloneDrawer: false,
      cloneData: {
        fromChannel: "",
        toChannel: "",
        forceClone: false,
        searchContent: '',
        placeContent: '',
        autoPlace: false
      },
      total: 0,
      pageSize: 30,
      currentPage: 1,
    };
  },
  async created() {
    this.channelList = await newChannelList();
    this.query(1);
  },
  methods: {
    guaranteedHandleCurrentChange(page) {
      this.query(page);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.query(1);
    },
    async query(page) {
      this.currentPage = page;
      this.login = true;
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_product_query +
        "?username=" +
        this.$store.getters.username +
        "&token=" +
        this.$store.getters.token,
        { channel: this.search.channel, page: this.currentPage,size:this.pageSize }
      );
      this.login = false;
      if (res.code != 0) return this.$message(res.msg);
      this.dataList = res.data.data;
      this.total = res.data.total;
      this.dataList.map((item) => {
        if (item.ctime !== 0)
          item.ctime = UTCTimeToDate(item.ctime, "yyyy-MM-dd HH:mm:ss");
        if (item.mtime !== 0)
          item.mtime = UTCTimeToDate(item.mtime, "yyyy-MM-dd HH:mm:ss");
      });
    },
    async queryNew(channel) {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_product_query +
        "?username=" +
        this.$store.getters.username +
        "&token=" +
        this.$store.getters.token,
        { channel: channel, page: 1 }
      );
      if (res.code != 0) return this.$message(res.msg);
      this.cloneData.searchContent = res.data.data[0].channelProductId || ''
    },
    sortByPrice(a, b) {
      return a.productPrice - b.productPrice;
    },
    operate(type, obj) {
      this.type = type;
      if (type === 2) {
        this.product = { ...obj };
      }
      this.dialog = true;
    },
    deleteProduct(id) {
      this.$confirm('确定删除该商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await this.$axios.get(
          this.$store.getters.path.config_delete_product +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token +
          "&id=" +
          id
        );
        if (res.code != 0) return this.$message(res.msg);
        this.$message.success("操作成功");
        this.query();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    async modifyProduct() {
      this.submitLoad = true;
      let data = {
        channel: this.product.channel,
        channelProductId: this.product.channelProductId,
        operator: this.$store.getters.username,
        payChannel: this.product.payChannel,
        productDesc: this.product.productDesc,
        productId: this.product.productId,
        productPrice: this.product.productPrice,
      };
      if (this.type === 2) {
        data.id = this.product.id;
      }
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_update_product +
        "?username=" +
        this.$store.getters.username +
        "&token=" +
        this.$store.getters.token,
        { data: data }
      );
      this.submitLoad = false;
      if (res.code != 0) return this.$message(res.msg);
      this.$message.success("操作成功");
      this.query();
      this.handleClose();
    },
    handleClose() {
      this.product = {
        channel: "",
        channelProductId: "",
        id: "",
        operator: "",
        payChannel: "",
        productDesc: "",
        productId: "",
        productPrice: "",
      };
      this.dialog = false;
    },
    async clone(type) {
      if (type == 1) {
        this.cloneDrawer = true;
      } else if (type == 2) {
        const { data: res } = await this.$axios.post(
          this.$store.getters.path.config_clone_product +
          "?username=" +
          this.$store.getters.username +
          "&token=" +
          this.$store.getters.token,
          { ...this.cloneData }
        );
        if (res.code != 0) return this.$message(res.msg);
        this.$message.success("操作成功");
        this.query();
        this.closeClone();
      }
    },
    closeClone() {
      this.cloneData = {
        fromChannel: "",
        toChannel: "",
        forceClone: false,
        searchContent: '',
        placeContent: '',
        autoPlace: false
      };
      this.cloneDrawer = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  display: flex;

  >* {
    margin: 0 5px;
  }
}

.item {
  display: flex;
  align-content: center;
  padding: 5px 0;

  span {
    line-height: 40px;
    padding: 0 5px;
    white-space: nowrap;
  }
}

.alist {
  padding: 0 20px;

  .item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
</style>
